import { useState } from 'react'

/** Микрофон для поля уточнения ИИ (Staff LK). */
export function VoiceClarifyMicButton({
  apiBase,
  authHeader,
  uiSurface,
  actionKey,
  misPatientId,
  disabled,
  onTranscript,
}: {
  apiBase: string
  authHeader: Record<string, string>
  uiSurface: string
  actionKey: string
  misPatientId: string
  disabled?: boolean
  onTranscript: (text: string) => void
}) {
  const [recording, setRecording] = useState(false)
  const [pending, setPending] = useState(false)
  const recorderRef = { current: null as MediaRecorder | null }
  const chunksRef = { current: [] as Blob[] }

  const transcribe = async (file: File) => {
    setPending(true)
    try {
      const form = new FormData()
      form.append('audio', file)
      form.append('ui_surface', uiSurface)
      form.append('action_key', actionKey)
      form.append('patient_id', misPatientId)
      const res = await fetch(`${apiBase}/staff/ai-assist/voice/transcribe`, {
        method: 'POST',
        headers: authHeader,
        body: form,
      })
      if (!res.ok) throw new Error(`transcribe HTTP ${res.status}`)
      const data = (await res.json()) as { transcript?: string; text?: string }
      const text = (data.transcript ?? data.text ?? '').trim()
      if (text) onTranscript(text)
    } finally {
      setPending(false)
    }
  }

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const recorder = new MediaRecorder(stream)
      chunksRef.current = []
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data)
      }
      recorder.onstop = () => {
        stream.getTracks().forEach((t) => t.stop())
        const blob = new Blob(chunksRef.current, { type: recorder.mimeType || 'audio/webm' })
        void transcribe(new File([blob], 'voice.webm', { type: blob.type }))
        setRecording(false)
      }
      recorder.start()
      recorderRef.current = recorder
      setRecording(true)
    } catch {
      setRecording(false)
    }
  }

  return (
    <button
      type="button"
      disabled={disabled || pending}
      onClick={() => (recording ? recorderRef.current?.stop() : void start())}
      className={`rounded-md px-2 py-1 text-[11px] ${
        recording ? 'bg-red-50 text-red-600' : 'border border-slate-300 bg-white text-slate-700'
      } disabled:opacity-50`}
      title="Надиктовать уточнение"
    >
      {pending ? '…' : recording ? '■ Стоп' : '🎙 Голос'}
    </button>
  )
}
